export class LinkBoxConstructionError extends Error {
    constructor(message) {
        super(message);
        this.name = 'LinkBoxConstructionError';
    }
}
